import { render } from "./AnimalHunt.vue?vue&type=template&id=1194699f&scoped=true"
import script from "./AnimalHunt.vue?vue&type=script&lang=js"
export * from "./AnimalHunt.vue?vue&type=script&lang=js"

import "./AnimalHunt.vue?vue&type=style&index=0&id=1194699f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1194699f"]])

export default __exports__